import { CfEditorialProps } from "./schema";
import { ContentfulLivePreview } from "@contentful/live-preview";
import { LiveInspectorData } from "types/types";
import {
  convertCfImageProps,
  convertSingleImage,
} from "components/Image/CfImage";
import { useContentfulLiveUpdates } from "@contentful/live-preview/react";
import Editorial, { EditorialProps } from "../index";
import Image from "components/Image";
import Markdown from "react-markdown";
import React from "react";

export const convertCfEditorialProps = ({
  title,
  description,
  imageHeading,
  centered,
  theme,
  size,
  titleTag,
  contentful_id,
}: CfEditorialProps) => {
  const liveInspector: LiveInspectorData = {
    editorial: ContentfulLivePreview.getProps({
      entryId: contentful_id,
      fieldId: "entryTitle",
    }),
  };

  const singleImage = convertSingleImage({
    image: imageHeading,
  });

  const updatedDescription =
    description && typeof description !== "string"
      ? description?.description
      : description;

  const props: EditorialProps = {
    title: title || undefined,
    description: updatedDescription ? (
      <Markdown>{updatedDescription}</Markdown>
    ) : undefined,
    theme: theme || "blue",
    centered: centered || false,
    size,
    titleTag,
    ...(singleImage && {
      image: <Image {...convertCfImageProps(singleImage)} />,
    }),
    liveInspector,
  };

  return props;
};

const CfEditorial = (props: CfEditorialProps) => {
  const liveProps = useContentfulLiveUpdates({
    ...props,
    sys: { id: props.contentful_id },
  });

  return <Editorial {...convertCfEditorialProps(liveProps)} />;
};

export default CfEditorial;
